/**
 * @param avatarImg
 * @param maxWidth
 * @param maxHeight
 */
export const resizeImage = (avatarImg: any, maxWidth: number, maxHeight: number) => {
    return new Promise<any>((resolve, reject) => {
        const image = new Image();
        image.onload = () => {
            let imageWidth = image.width;
            let imageHeight = image.height;

            if (imageWidth > imageHeight) {
                if (imageWidth > maxWidth) { imageHeight *= maxWidth / imageWidth; imageWidth = maxWidth; }
            }
            else if (imageHeight > maxHeight) { imageWidth *= maxHeight / imageHeight; imageHeight = maxHeight; }

            const canvas = document.createElement("canvas");
            canvas.width = imageWidth;
            canvas.height = imageHeight;
            image.width = imageWidth;
            image.height = imageHeight;
            image.crossOrigin = "Anonymous";
            const ctx = canvas.getContext("2d");
            if (!ctx) {
                throw new Error("failed to get 2d context");
            }
            ctx.drawImage(image, 0, 0, imageWidth, imageHeight);
            const resizedImage = new Image();
            resizedImage.src = canvas.toDataURL("image/png");
            resolve(resizedImage);
        };
        image.onerror = () => {
            reject();
        };
        image.src = avatarImg;
    });
};

/**
 * @param image
 */
export const getBinaryData = (image: any) => {
    const typeIndex = image.src.indexOf("image/") + 6;
    const binaryIndex = image.src.indexOf(";base64,");
    const binaryData = image.src.slice(binaryIndex + 8);
    const imageType = image.src.slice(typeIndex, binaryIndex);
    const binaryString = window.atob(binaryData);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) { bytes[i] = binaryString.charCodeAt(i); }
    return { type: imageType, data: bytes };
};

export const getBase64Image = async(url: string): Promise<string> => {
    return new Promise((resolve) => {
        const image = new Image();
        image.crossOrigin = 'anonymous';
        const canvas = document.createElement('canvas');
        image.onload = () => {
            canvas.width = image.width;
            canvas.height = image.height;
            const ctx = canvas.getContext('2d');
            if (!ctx) {
                throw new Error("failed to get 2d context");
            }
            ctx.drawImage(image, 0, 0);
            resolve(canvas.toDataURL("image/png"));
        };
        image.src = url;
    });
};
